export default __webpack_public_path__ + "static/media/linkedin.7e0ee31a.png";